export default "__VITE_PUBLIC_ASSET__62aa22ec__"